<app-nine-sliced-sprite
  src="assets/placeholders/conveyor-belt.png"
  width="476px"
  [x]="[0.26, 0.66]"
  [y]="[0.5, 0.5]"
></app-nine-sliced-sprite>
